import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import vuetify from './plugins/vuetify';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Highcharts from 'highcharts';
import HighchartsVue from 'highcharts-vue';
import stockInit from 'highcharts/modules/stock';
import exportingInit from 'highcharts/modules/exporting';
import Croppa from 'vue-croppa';
import VueTimeago from 'vue-timeago';
import Notifications from 'vue-notification';
import 'vue-croppa/dist/vue-croppa.css';

// firebase
import firebase from 'firebase/app';
import 'firebase/messaging';
firebase.initializeApp({
  apiKey: 'AIzaSyDBf2o3naRFmUtPs3WbHr74j3Vp92nX-QM',
  authDomain: 'eoffice-mobile-6b157.firebaseapp.com',
  projectId: 'eoffice-mobile-6b157',
  storageBucket: 'eoffice-mobile-6b157.appspot.com',
  messagingSenderId: '542476403131',
  appId: '1:542476403131:web:0c6e49b426d83e5807849e',
});
navigator.serviceWorker
  .register('firebase-messaging-sw.js')
  .then((registration) => {
    const messaging = firebase.messaging();
    messaging.useServiceWorker(registration);
  })
  .catch((err) => {
    console.log(err);
  });

Vue.config.productionTip = false;

stockInit(Highcharts);
exportingInit(Highcharts);

Vue.use(VueAxios, axios);
Vue.use(HighchartsVue);
// Vue.use(require('vue-moment'));
Vue.use(Croppa);
Vue.use(VueTimeago, {
  name: 'timeago', // component name, `timeago` by default
  locale: 'en-US',
});
Vue.use(Notifications);

import './scss/main.scss';

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
